<template>
  <div>
    <SectionHeader>
      <h1>Reset Your Password</h1>
    </SectionHeader>
    <SectionWrapper>
      <Remind @continue="emitContinue" />
    </SectionWrapper>
  </div>
</template>

<script>
import Remind from "@/components/partials/auth/password/Remind";

export default {
  name: "auth-password-reminder",
  components: { Remind },
  methods: {
    emitContinue() {
      this.$emit("continue");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
